import { useMutation } from "@apollo/client";
import { SAVE_COMPANY_DOCUMENT } from "../api/save-company-document";
import { useNotification } from "@/shared/feedback/notification";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { FIND_COMPANY_DOCUMENTS } from "@/modules/documents/widgets/company-documents-list";
import { GET_COMPANY_DOCUMENT_TREE } from "@/modules/documents/widgets/company-document-tree";
import { FieldsType } from "./types";

export function useSaveCompanyDocumentMutation({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const t = useDocumentsTranslations();
  const [saveDocument, { loading }] = useMutation(SAVE_COMPANY_DOCUMENT, {
    refetchQueries: [FIND_COMPANY_DOCUMENTS, GET_COMPANY_DOCUMENT_TREE],
  });
  const notify = useNotification();

  const save = async (document: FieldsType) => {
    const response = await saveDocument({ variables: { document } });

    if (response.data?.saveCompanyDocument) {
      notify?.success({
        message: t("Document saved successfully"),
      });

      afterSubmit?.();
    }
  };

  return {
    save,
    loading,
  };
}
